import { loadPng } from "@/lib/pngCache";

export const PALETTE = [
  { key: "branco", label: "Branco", hex: "#FFFFFF" },
  { key: "offwhite", label: "Off-white", hex: "#F4EEE4" },
  { key: "preto", label: "Preto", hex: "#1F1D1C" },
  { key: "cinza", label: "Cinza", hex: "#8E8B89" },
  { key: "cinza-claro", label: "Cinza claro", hex: "#CFCBC8" },
  { key: "nude", label: "Nude", hex: "#E2C2A9" },
  { key: "bege", label: "Bege", hex: "#CDB596" },
  { key: "marrom", label: "Marrom", hex: "#7A5240" },
  { key: "rosa", label: "Rosa", hex: "#E8A0AE" },
  { key: "rose", label: "Rosé", hex: "#C58B90" },
  { key: "vermelho", label: "Vermelho", hex: "#C8102E" },
  { key: "rosa-pastel", label: "Rosa pastel", hex: "#F7CDD5" },
  { key: "lilas", label: "Lilás pastel", hex: "#CDB9E4" },
  { key: "azul", label: "Azul pastel", hex: "#B7D2EB" },
  { key: "verde", label: "Verde pastel", hex: "#BDD8C0" },
  { key: "amarelo", label: "Amarelo pastel", hex: "#F4E0A3" },
  { key: "dourado", label: "Dourado", hex: "#D4AF37", gradient: ["#F3DE8A", "#D4AF37", "#A67C1A", "#E9C96A"] },
];

export const swatchStyle = (c) =>
  c.gradient ? { backgroundImage: `linear-gradient(135deg, ${c.gradient.join(", ")})` } : { backgroundColor: c.hex };

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
export const sameColor = (a, b) => rgb(a).reduce((s, v, i) => s + (v - rgb(b)[i]) ** 2, 0) < 150;

const tinted = new Map();

// Paints every visible pixel of the PNG with the color, keeping transparency
export function tintPng(url, color) {
  const id = `${url}|${color.key}`;
  if (!tinted.has(id)) {
    const p = loadPng(url)
      .then(({ objectUrl }) => new Promise((res, rej) => {
        const img = new Image();
        img.onload = () => res(img);
        img.onerror = rej;
        img.src = objectUrl;
      }))
      .then((img) => {
        const c = document.createElement("canvas");
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0);
        ctx.globalCompositeOperation = "source-in";
        if (color.gradient) {
          const g = ctx.createLinearGradient(0, 0, c.width, c.height);
          color.gradient.forEach((h, i) => g.addColorStop(i / (color.gradient.length - 1), h));
          ctx.fillStyle = g;
        } else {
          ctx.fillStyle = color.hex;
        }
        ctx.fillRect(0, 0, c.width, c.height);
        return new Promise((res) => c.toBlob(res, "image/png"));
      })
      .then((blob) => ({ blob, objectUrl: URL.createObjectURL(blob) }));
    p.catch(() => tinted.delete(id));
    tinted.set(id, p);
  }
  return tinted.get(id);
}
